<template>
    <i
        style="font-size: 18px; color: rgb(var(--green))"
        class="iconsax"
        icon-name="tick-square"></i>
</template>
